import { useTranslation } from 'react-i18next';
import ExampleInstruction from '../ExampleInstruction';

const SearchArticlesInstructions = () => {
	const { t } = useTranslation();
	return (
		<div className='search-articles-instructions flex flex-wrap gap-8 '>
			<div className='left-side bg-white rounded-md flex-1 p-4  text-sm text-center flex justify-center items-center min-w-[310px]'>
				{t('Crafting effective search queries')}
			</div>
			<div className='right-side flex-1 bg-white rounded-md p-6 text-sm min-w-[310px]'>
				<p className='font-bold'>{t('To refine your searches you can use')}:</p>
				<ul className='flex flex-col gap-y-1 mt-2'>
					<li className='flex items-center'>
						<div className='bg-gray-200/70 flex items-center justify-center rounded-md p-2 w-28 min-w-[98px] h-8 text-center text-base font-bold text-[#0a6d7b]'>
							" "
						</div>
						<p className='pl-4'>{t('to specify exact matching')}</p>
						<ExampleInstruction message={[`"${t('Pediatric phlebotomy')}"`]} />
					</li>
					<li className='flex items-center'>
						<div className='bg-gray-200/70 flex items-center justify-center rounded-md p-2 w-28 min-w-[98px] h-8 text-center text-[10.5px] font-bold text-[#0a6d7b]'>
							AND, OR, NOT
						</div>
						<p className='pl-4'> {t('to add logic to to your search')}</p>
						<ExampleInstruction message={[`"${t('Pediatric phlebotomy')}"`]} />
					</li>
					<li className='flex items-center'>
						<div className='bg-gray-200/70 flex items-center justify-center rounded-md p-2 w-28 min-w-[98px] h-8 text-center text-xs font-bold text-[#0a6d7b]'>
							( )
						</div>
						<p className='pl-4'> {t('to group your search terms')}</p>
						<ExampleInstruction message={[`"${t('Pediatric phlebotomy')}"`]} />
					</li>
				</ul>
			</div>
		</div>
	);
};

export default SearchArticlesInstructions;
